import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


const INSTAGRAM_URL =  "https://www.instagram.com/"
const POSFIX = "/?__a=1"
// https://www.instagram.com/anacimen/?__a=1

const header = {'Access-Control-Allow-Origin':'*'}

export class InstagramApi {

    static async getUserProfilePic(username) {
        let url = INSTAGRAM_URL + username + POSFIX
        fetch(url,{mode: 'no-cors'}).then(response => {
            return response.graphql.user.profile_pic_url
        })
      
    }
}



// WEBPACK FOOTER //
// ./src/api/instagram_api.js